import React, { useEffect, useState } from 'react';
import {
  GoalsAddButtonMobile,
  GoalsEmptyContainer,
  GoalsEmptyImage,
  GoalsEmptyText,
  GoalsEmptyTitle,
  GoalsMobilePopupTarget,
  GoalsTabContainer,
} from './styles/Goals.styled';
import { LoadingSpinner } from 'src/components/common/LoadingSpinner/LoadingSpinner';
import { useGetPeriods } from './hooks/useGetPeriods';
import { GoalsHeader } from 'src/components/Goals/GoalsHeader/GoalsHeader';
import { GoalsTable } from 'src/components/Goals/GoalsTable/GoalsTable';
import { GoalsRowHeader } from 'src/components/Goals/GoalsRowHeader/GoalsRowHeader';
import { useGetUserGoals } from './hooks/useGetUserGoals';
import { goalsMapperPerStatus } from './utils/employeeGoalsMapperByStatus';
import { useAlertMessage } from 'src/hooks/useAlertMessage';
import EmptyGoalsImage from 'src/assets/skillsFindExpertImage.png';
import { AddNewGoalButton } from 'src/components/Goals/GoalsTable/style/GoalsTable.styled';
import { Add20Regular as AddRegular } from '@fluentui/react-icons';
import { Add20Filled as AddIcon } from '@fluentui/react-icons';
import { isMobile } from 'react-device-detect';

export const Goals = () => {
  const {
    showAlert,
    hideAlert,
    requestStatusAppearance,
    requestStatusMessage,
  } = useAlertMessage();
  const { activePeriods, loadingActivePeriods } = useGetPeriods();
  const [selectedPeriod, setSelectedPeriod] = useState<string>('');
  const [isAdding, setIsAdding] = useState(false);

  const { goals, loadingGoals, getAllUserGoals } =
    useGetUserGoals(selectedPeriod);
  const mappedGoalsByStatus = goalsMapperPerStatus(goals);

  const [showInvalidPeriods, setShowInvalidPeriods] = useState<boolean>(false);
  const [isReadOnlyPeriod, setIsReadOnlyPeriod] = useState<boolean>(false);
  const [target, setTarget] = React.useState<HTMLElement | null>(null);

  useEffect(() => {
    if (activePeriods.length === 0) return;

    setSelectedPeriod(activePeriods[0]?.new_axsperiodid);
  }, [activePeriods]);

  if (loadingActivePeriods || loadingGoals) return <LoadingSpinner />;
  return (
    <GoalsTabContainer>
      {!isAdding && isMobile && goals.length > 0 && (
        <GoalsAddButtonMobile onClick={() => setIsAdding(true)}>
          <AddIcon />
          &nbsp;New goal
        </GoalsAddButtonMobile>
      )}
      <GoalsHeader
        activePeriods={activePeriods}
        selectedPeriod={selectedPeriod}
        setSelectedPeriod={setSelectedPeriod}
        showInvalidPeriods={showInvalidPeriods}
        setShowInvalidPeriods={setShowInvalidPeriods}
        setIsReadOnlyPeriod={setIsReadOnlyPeriod}
      />
      {!isMobile && (
        <GoalsRowHeader
          requestStatusMessage={requestStatusMessage}
          requestStatusAppearance={requestStatusAppearance}
          hideAlert={hideAlert}
        />
      )}
      {!goals.length && !isAdding && !loadingGoals ? (
        <GoalsEmptyContainer>
          <GoalsEmptyImage src={EmptyGoalsImage} />
          <GoalsEmptyTitle>
            {isReadOnlyPeriod
              ? 'This period is inactive'
              : 'Still quite empty here'}
          </GoalsEmptyTitle>
          {!isReadOnlyPeriod && (
            <>
              <GoalsEmptyText>
                {`You're lucky! This period is still active and you can get some goals now!`}
              </GoalsEmptyText>
              <AddNewGoalButton
                className="maxWidth"
                onClick={() => setIsAdding(true)}
              >
                <AddRegular />
                &nbsp; Add a new goal
              </AddNewGoalButton>
            </>
          )}
        </GoalsEmptyContainer>
      ) : (
        <GoalsTable
          goals={mappedGoalsByStatus}
          selectedPeriod={selectedPeriod}
          getAllUserGoals={getAllUserGoals}
          showAlert={showAlert}
          setIsAdding={setIsAdding}
          isAdding={isAdding}
          requestStatusMessage={requestStatusMessage}
          requestStatusAppearance={requestStatusAppearance}
          hideAlert={hideAlert}
          isReadOnlyPeriod={isReadOnlyPeriod}
          target={target}
        />
      )}
      <GoalsMobilePopupTarget ref={setTarget}></GoalsMobilePopupTarget>
    </GoalsTabContainer>
  );
};
